import { withQuery } from 'ufo'

export function useCreateConfDataURLFn() {
  const partner = usePartner()
  const { origin } = useRequestURL()

  return (url: MaybeRefOrGetter<URL>) =>
    new URL(
      withQuery(getUrlFullPath(normalizeUrl(toValue(url))), {
        partnerid: partner.id || undefined,
      }),
      origin,
    )
}

export function useConfDataURL(currentUrl: MaybeRefOrGetter<URL>) {
  const createConfDataUrl = useCreateConfDataURLFn()

  return computed(() => createConfDataUrl(currentUrl))
}

export function useContentWidth(size: ScreenSize = 'lg') {
  const confData = useConfdata()

  const isContentFullWidth = computed(() => confData.pagetype === 'search')

  const contentWidthClass = computed(() =>
    isContentFullWidth.value ? `container-fluid-xl` : `container-fluid-${size}`,
  )

  return { isContentFullWidth, contentWidthClass }
}
